
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  newButtonsNewFolder: {
    id: "NewButtonsNewFolder.text",
    defaultMessage: "New Folder",
  }, 
  newButtonsNewConfiguration: {
    id: "NewButtonsNewConfiguration.text",
    defaultMessage: "Create Configuration",
  }, 
});

export default MESSAGES;